import moment from "moment";

export const todaysDate = () => {
   return moment(new Date()).format("DD/MM/YYYY")
};

export const formatDate = (date) => {
    return moment(date).format("DD/MM/YYYY")
 };